import { array, object, string } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const ProductGroupSchema = object({
  id: string(),
  name: string(),
});

export const ProductGroupsSchema = array(ProductGroupSchema, { required_error: IS_REQUIRED }).min(
  1,
  IS_REQUIRED,
);
